import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const OfflineTest = () => {
  const navigate = useNavigate();
  const [result, setResult] = useState('');

  const testOffline = () => {
    try {
      // Simulate trip creation without Firebase
      const mockTripId = 'mock_trip_' + Date.now();
      const tripData = {
        id: mockTripId,
        name: 'Mock Trip ' + new Date().toLocaleTimeString(),
        description: 'This is a mock trip (offline test)',
        currency: 'USD',
        members: ['user@example.com', 'test@example.com'],
        totalSpent: 0,
        createdAt: new Date()
      };

      console.log('✅ Mock trip created:', tripData);
      setResult(`✅ Mock trip created! ID: ${mockTripId}`);
      
      // Save to localStorage for testing
      localStorage.setItem('mockTrip', JSON.stringify(tripData));
      
      setTimeout(() => {
        navigate('/dashboard');
      }, 2000);
      
    } catch (error) {
      console.error('❌ Mock test failed:', error);
      setResult(`❌ Mock test failed: ${error.message}`);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-md mx-auto">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">Offline Test</h1>
        
        <div className="bg-white rounded-lg shadow p-6 mb-4">
          <p className="text-gray-600 mb-4">
            This test creates a mock trip without Firebase to verify the UI works.
          </p>
          
          <button
            onClick={testOffline}
            className="w-full px-4 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700"
          >
            Create Mock Trip (Offline)
          </button>
        </div>

        {result && (
          <div className={`p-4 rounded-lg ${
            result.includes('✅') ? 'bg-green-50 border border-green-200' : 
            'bg-red-50 border border-red-200'
          }`}>
            <pre className="text-sm">{result}</pre>
          </div>
        )}

        <div className="mt-4 space-y-2">
          <button
            onClick={() => navigate('/dashboard')}
            className="block w-full text-center text-blue-600 hover:text-blue-700 underline"
          >
            Back to Dashboard
          </button>
          <button
            onClick={() => navigate('/simple-create-trip')}
            className="block w-full text-center text-blue-600 hover:text-blue-700 underline"
          >
            Try Firebase Test Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default OfflineTest;
